import { LineOfBusinessConfig } from "../claimsSearchBar/ClaimsSearchBar";
import { SEARCH_PARAMETERS } from "../searchResults/constants";
import { ROUTES } from "src/app/constants";

// Workers Compensation specific search configuration
export const WC_LINE_OF_BUSINESS_CONFIG: LineOfBusinessConfig = {
  searchByLabels: {
    [SEARCH_PARAMETERS.ALIAS]: {
      buttonText: "Search by Alias/Login",
      buttonTextSmall: "By Alias",
      placeholder: "Search for claims using the injured employee's alias/login",
      placeholderSmall: "Search using alias/login",
    },
    [SEARCH_PARAMETERS.EMPLOYEE_ID]: {
      buttonText: "Search by Employee ID",
      buttonTextSmall: "By EID",
      placeholder: "Search for claims using the injured employee's ID",
      placeholderSmall: "Search using Employee ID",
    },
    [SEARCH_PARAMETERS.SITE]: {
      buttonText: "Search by Incident Site",
      buttonTextSmall: "By Site",
      placeholder: "Search for claims using the Incident Site",
      placeholderSmall: "Search using Site",
    },
  },
  availableSearchParameters: [
    SEARCH_PARAMETERS.ALIAS,
    SEARCH_PARAMETERS.EMPLOYEE_ID,
    SEARCH_PARAMETERS.SITE,
  ],
  routePath: ROUTES.CLAIMS_HISTORY,
  metricsPrefix: "claims",
};
